import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { NO, YES } from "const"
import {
    StoreType,
    ChangePackageSettings,
    setPackageSettings,
} from "client/store"
import {
    Collapse,
    PageForm,
    FormGroup,
    Label,
    RadioButton,
} from "client/components"

const Study = () => {
    const settings = useSelector((state: StoreType) => state.package.packageSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (newSettings: ChangePackageSettings) => {
        dispatch(setPackageSettings(newSettings))
    }

    const { studyModuleAccess } = settings

    return (
        <Collapse
            show={show}
            title={lang.study}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>{lang.studyModuleAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={studyModuleAccess === NO}
                            onChange={() => onChange({ studyModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={studyModuleAccess === YES}
                            onChange={() => onChange({ studyModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default Study
